import { Flex, Skeleton, Text } from "@gravity-ui/uikit";
import { useAction } from "@reatom/npm-react";
import classNames from "classnames";
import { CounterType } from "definitions/poizon-bff";
import React, { useEffect, useState } from "react";
import { API } from "src/api";

import { isOpenPromotionModalAtom } from "../../store/atoms/promotionModalAtom";
import { getSubscribePriceRequest } from "../../store/fetchers/getSubscribePrice";
import { SubscribeBase } from "../../SubscribePage.constants";
import {
  calculateMaxRequests,
  configValueToString,
  keyToString,
  numberToCurrencyNumber,
} from "../../util";
import css from "./SubscribeCard.module.scss";

export interface SubscribeCardProps extends SubscribeBase {
  type: CounterType;
  active?: boolean;
  onClick?: () => void;
}

export const SubscribeCard = ({
  type,
  title,
  config,
  active,
  promotion,
  onClick,
}: SubscribeCardProps) => {
  const [price, setPrice] = useState<number>(0);
  const [isLoading, setIsLoading] = useState(true);
  const setIsOpenPromotion = useAction(isOpenPromotionModalAtom);

  const getSubscribePrice = useAction(getSubscribePriceRequest);

  useEffect(() => {
    // eslint-disable-next-line react-you-might-not-need-an-effect/no-event-handler -- загрузка цены по config (data fetch); страница deprecated
    if (promotion) {
      return;
    }

    API.subscribeApi
      .subscribeControllerCalculatePrice({
        type,
        rps: config.rps,
        requestCount: config.requests
          ? config.requests
          : calculateMaxRequests(config.rps),
        withExport: config.withExport,
      })
      .then((data) => {
        setPrice(data.data.price);
        setIsLoading(false);
      });
  }, [config, type, getSubscribePrice, promotion]);

  return (
    <div
      className={classNames(
        css.subscribeCardContainer,
        promotion && css.promotionCardContainer,
      )}
      style={{
        outline: active ? "1px solid var(--g-color-base-brand)" : "",
      }}
      onClick={!promotion ? onClick : () => setIsOpenPromotion((prev) => !prev)}
    >
      <Flex direction="column" gap={2}>
        <Text variant="body-2">{title}</Text>
        <Text variant="subheader-1" color="brand">
          {promotion ? (
            "Бесплатно"
          ) : (
            <>
              {isLoading ? (
                <Skeleton style={{ height: 29 }} />
              ) : (
                <>{numberToCurrencyNumber(price)}/мес</>
              )}
            </>
          )}
        </Text>
      </Flex>

      <Flex direction="column" gap={2}>
        <Text variant="subheader-1" style={{ marginBottom: 4 }}>
          Конфигурация:
        </Text>
        <div className={css.configContainer}>
          {Object.entries(config).map(([key, value]) => {
            return (
              <React.Fragment key={key}>
                <Text
                  variant="body-1"
                  color="info"
                  style={{ fontWeight: "bold" }}
                >
                  {configValueToString(value)}
                </Text>
                <Text variant="body-1" style={{ textAlign: "end" }}>
                  {keyToString[key]}
                </Text>
              </React.Fragment>
            );
          })}
        </div>
      </Flex>
    </div>
  );
};
